import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { getStateDataById } from '../selectLists/states/mockData'
import type { TEntityId } from '~/types/models'
import type { ISupplierResource } from '~/types/supplier/models'
import {
  getResourceUseById,
  ResourceUseIds,
} from '~/services/selectLists/resourceUses'
import { getCountryDataById } from '~/api/msw/api/selectLists/countries/mockData'
import { CountryIds } from '~/services/selectLists/countries'

const supplierResourceListData = undefined as unknown as ISupplierResource[]

export const getSupplierResourceListData = getListDataFunctionFactory<
  ISupplierResource[]
>({
  listData: supplierResourceListData,
  storageKey: 'supplierresources',
  getStartingListData: getStartingSupplierResourceListData,
})

export async function getSupplierResourceDataById(
  id: TEntityId
): Promise<ISupplierResource> {
  const list: ISupplierResource[] = await getSupplierResourceListData()
  if (!list) {
    throw new Error(`getSupplierResourceList returned undefined/null`)
  }
  const sre = list.find((supplierResource) => supplierResource.id === id)
  if (!sre) {
    throw new Error(`Can't find resource '${id}'`)
  }
  return sre
}

export async function getSupplierResourceListDataBySupplierId(id: string) {
  const list = await getSupplierResourceListData()
  if (!list) {
    throw new Error(`getSupplierResourceList returned undefined/null`)
  }
  return list.filter((supplierResource: ISupplierResource) =>
    isEqual(supplierResource.supplier?.id, id)
  ) as ISupplierResource[]
}

export async function getSupplierResourceListDataWithUseForRegistrationBySupplierId(
  id: string
) {
  const list = await getSupplierResourceListData()
  if (!list) {
    throw new Error(`getSupplierResourceList returned undefined/null`)
  }
  return list.filter(
    (supplierResource: ISupplierResource) =>
      isEqual(supplierResource.supplier?.id, id) &&
      supplierResource.useFor?.find(
        (uf) => uf.id === ResourceUseIds.REGISTRATIONS
      )
  ) as ISupplierResource[]
}

export async function getStartingSupplierResourceListData(): Promise<
  ISupplierResource[]
> {
  const unitedStates = await getCountryDataById(CountryIds.UNITED_STATES)
  const massachusetts = await getStateDataById(1433)
  return [
    {
      id: 'XXSRE0001',
      hrid: 'SRE0001',
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      descr: 'Registration Desk',
      email: 'registrations@cogent.net',
      // Schemeless on purpose — that is how a user types a website into the
      // form, and it is the case TableCard has to prefix with https:// rather
      // than treat as a route inside the app.
      websiteUrl: 'www.cogentco.com/registrations',
      address: {
        country: unitedStates,
        addressLine1: '456 Somewhere Street',
        addressLine2: 'Suite 310',
        city: 'Boston',
        state: massachusetts,
        zip: '04359',
      },
      useFor: [getResourceUseById(ResourceUseIds.REGISTRATIONS)],
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXSRE0002',
      hrid: 'SRE0002',
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      descr: 'RFQ Email',
      email: 'rfp@cogent.net',
      websiteUrl: 'https://www.cogentco.com/quotes',
      address: {
        country: unitedStates,
        addressLine1: '456 Somewhere Street',
        addressLine2: 'Suite 314',
        city: 'Boston',
        state: massachusetts,
        zip: '04359',
      },
      useFor: [getResourceUseById(ResourceUseIds.RFQS)],
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
